import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export const getMe = async (): Promise<any> => {
    const token = sessionStorage.getItem("token");

    if (!token) {
        throw new Error("No auth token found");
    }

    const { data } = await gatewayPageBuilder.get("page-builder/me", {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    return data;
};
